import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AnalyticsEvent {
    public static Filter = 'filter';
    public static DownloadGoogleChrome = 'download google chrome';
    public static DownloadFirefox = 'download firefox';
    public static LeavePage = 'left page';
    public static Tour = 'tour';
    public static Export = 'export';
    public static EmailExport = 'email export';
    public static EnrollmentRedirectLogin = 'enrollment redirect to login';
}

@Injectable({ providedIn: 'root' })
export class AnalyticsProp {
    public static CompanyName = 'companyName';
    public static DateOffset = 'dateOffset';
    public static Email = 'email';
    public static EndDateOffset = 'endDateOffset';
    public static FilterType = 'filterType';
    public static FirstName = 'firstName';
    public static IsAdmin = 'isAdmin';
    public static LastName = 'lastName';
    public static ReportName = 'reportName';
    public static StartDateOffset = 'startDateOffset';
    public static UserName = 'userName';
    public static FileType = 'fileType';
}

@Injectable({ providedIn: 'root' })
export class AnalyticsValue {
    public static DateFilter = 'date';
    public static EventCategoryFilter = 'filter';
    public static TourCompleted = 'completed';
    public static TourSkipped = 'skipped';
}
